module.exports = __webpack_public_path__ + "img/gameNameBg.b9125857.png";